// extracted by mini-css-extract-plugin
export default {"error":"_3zeVF3y9OTpSql8K981Mit","bday":"pi8BGi3PtlnMFrlnWtyMn","input":"uSu6bXnjlFoYaikOsuuXp","bdayInputContainer":"_3RuhyJTJjzYWN6r9EEYZHm","basic":"_1QZyS9YVGcxinLdbivDaxH"};